module.exports = __webpack_public_path__ + "img/tips-medical-icon.b383a682.svg";